import React, { useState, useEffect, useCallback } from 'react';

function getToken() { return localStorage.getItem('authToken') || ''; }
function h() { return { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'application/json' }; }

function timeAgo(d: string) {
  if (!d) return '';
  const diff = Date.now() - new Date(d).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 2) return "à l'instant";
  if (m < 60) return `il y a ${m}min`;
  const hr = Math.floor(m / 60);
  if (hr < 24) return `il y a ${hr}h`;
  const day = Math.floor(hr / 24);
  return `il y a ${day}j`;
}

const PLATFORM_CONFIG: Record<string, { label: string; color: string; bg: string; border: string; icon: React.ReactNode }> = {
  facebook: {
    label: 'Facebook', color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-blue-200',
    icon: <svg viewBox="0 0 24 24" fill="#1877f2" className="w-3.5 h-3.5"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>,
  },
  instagram: {
    label: 'Instagram', color: 'text-pink-600', bg: 'bg-pink-50', border: 'border-pink-200',
    icon: <svg viewBox="0 0 24 24" fill="#e1306c" className="w-3.5 h-3.5"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>,
  },
  google_my_business: {
    label: 'Google', color: 'text-emerald-700', bg: 'bg-emerald-50', border: 'border-emerald-200',
    icon: <svg viewBox="0 0 24 24" className="w-3.5 h-3.5"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>,
  },
  linkedin: {
    label: 'LinkedIn', color: 'text-sky-700', bg: 'bg-sky-50', border: 'border-sky-200',
    icon: <svg viewBox="0 0 24 24" fill="#0077b5" className="w-3.5 h-3.5"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>,
  },
};

function Stars({ rating }: { rating: string | null }) {
  const map: Record<string, number> = { ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5 };
  const n = rating ? (map[rating] ?? parseInt(rating) ?? null) : null;
  if (!n) return null;
  return (
    <span className="flex items-center gap-0.5 ml-1">
      {[1,2,3,4,5].map(i => (
        <svg key={i} viewBox="0 0 20 20" fill="currentColor" className={`w-3 h-3 ${i <= n ? 'text-amber-400' : 'text-gray-200'}`}>
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
        </svg>
      ))}
    </span>
  );
}

type Message = {
  id: string; platform: string; type: string;
  author: { name: string; avatar?: string };
  content: string; date: string; postSnippet: string;
  meta: Record<string, any>; rating: string | null; replied: boolean;
};

export default function InboxPage() {
  const [messages, setMessages]   = useState<Message[]>([]);
  const [stats, setStats]         = useState<any>(null);
  const [loading, setLoading]     = useState(true);
  const [filter, setFilter]       = useState('all');
  const [replyingTo, setReplyingTo] = useState<string | null>(null);
  const [replyText, setReplyText] = useState('');
  const [sending, setSending]     = useState(false);
  const [replied, setReplied]     = useState<Set<string>>(new Set());
  const [error, setError]         = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/inbox', { headers: h() }).then(r => r.json());
      if (res.success) { setMessages(res.messages); setStats(res.stats); }
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = messages.filter(m => {
    if (filter === 'all') return true;
    if (filter === 'to_reply') return !m.replied && !replied.has(m.id) && m.type !== 'reply';
    return m.platform === filter;
  });

  const handleReply = async (msg: Message) => {
    if (!replyText.trim()) return;
    setSending(true);
    setError(null);
    try {
      const res = await fetch('/api/inbox/reply', {
        method: 'POST', headers: h(),
        body: JSON.stringify({ platform: msg.platform, meta: msg.meta, replyText }),
      }).then(r => r.json());
      if (res.success) {
        setReplied(prev => new Set([...prev, msg.id]));
        setReplyingTo(null);
        setReplyText('');
      } else {
        setError(res.error || 'Erreur lors de la réponse.');
      }
    } catch {
      setError('Erreur réseau.');
    }
    setSending(false);
  };

  const filterTabs = [
    { key: 'all',      label: 'Tous',      count: stats?.total },
    { key: 'to_reply', label: 'À répondre', count: stats?.toReply, accent: true },
    { key: 'google_my_business', label: 'Google',    count: stats?.gmb },
    { key: 'facebook',           label: 'Facebook',  count: stats?.facebook },
    { key: 'instagram',          label: 'Instagram', count: stats?.instagram },
    { key: 'linkedin',           label: 'LinkedIn',  count: stats?.linkedin },
  ];

  if (loading) return (
    <div className="flex items-center justify-center py-20">
      <div className="text-center">
        <div className="animate-spin inline-block w-10 h-10 border-4 border-violet-500 border-t-transparent rounded-full mb-4" />
        <p className="text-gray-500 text-sm">Chargement des messages…</p>
      </div>
    </div>
  );

  return (
    <div className="space-y-5">

      {/* KPIs */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label: 'Total messages',  value: stats?.total ?? 0,   grad: 'from-violet-600 to-indigo-600', icon: '💬' },
          { label: 'À répondre',      value: stats?.toReply ?? 0, grad: 'from-rose-500 to-pink-600',     icon: '⏳', alert: (stats?.toReply ?? 0) > 0 },
          { label: 'Avis Google',     value: stats?.gmb ?? 0,     grad: 'from-emerald-500 to-teal-600',  icon: '⭐' },
          { label: 'Commentaires',    value: (stats?.facebook ?? 0) + (stats?.instagram ?? 0) + (stats?.linkedin ?? 0),
            grad: 'from-blue-500 to-sky-600', icon: '📣' },
        ].map(k => (
          <div key={k.label} className={`rounded-2xl bg-gradient-to-br ${k.grad} p-5 text-white shadow-md relative overflow-hidden`}>
            <div className="absolute top-3 right-4 text-2xl opacity-25">{k.icon}</div>
            <p className="text-white/70 text-[11px] font-bold uppercase tracking-widest mb-1">{k.label}</p>
            <p className="text-4xl font-black">{k.value}</p>
            {'alert' in k && k.alert && <p className="text-white/80 text-[10px] mt-1 font-semibold">⚠ En attente de réponse</p>}
          </div>
        ))}
      </div>

      {/* Inbox */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">

        {/* Header */}
        <div className="bg-gradient-to-r from-slate-800 to-slate-700 px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4 text-white">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/>
            </svg>
            <h3 className="font-bold text-white text-sm">Boîte de réception unifiée</h3>
          </div>
          <button onClick={load} className="text-white/60 hover:text-white transition-colors p-1" title="Rafraîchir">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
          </button>
        </div>

        {/* Filter tabs */}
        <div className="flex gap-1.5 px-5 py-3 border-b border-gray-100 bg-gray-50 overflow-x-auto">
          {filterTabs.map(tab => (
            <button key={tab.key} onClick={() => setFilter(tab.key)}
              className={`shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all border ${
                filter === tab.key
                  ? tab.accent ? 'bg-rose-600 text-white border-rose-600' : 'bg-violet-600 text-white border-violet-600'
                  : 'bg-white text-gray-600 border-gray-200 hover:border-violet-300 hover:text-violet-600'
              }`}>
              {tab.label}
              {tab.count != null && tab.count > 0 && (
                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                  filter === tab.key ? 'bg-white/25 text-white' : 'bg-gray-100 text-gray-500'
                }`}>{tab.count}</span>
              )}
            </button>
          ))}
        </div>

        {/* Error */}
        {error && (
          <div className="mx-5 mt-3 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-2.5 rounded-xl">
            <span>❌</span> {error}
            <button onClick={() => setError(null)} className="ml-auto text-red-400 hover:text-red-600">✕</button>
          </div>
        )}

        {/* Messages */}
        {filtered.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <p className="text-4xl mb-3">📭</p>
            <p className="text-sm font-medium">Aucun message pour ce filtre</p>
            <p className="text-xs mt-1">Les commentaires et avis de vos réseaux apparaîtront ici.</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-50">
            {filtered.map(m => {
              const cfg = PLATFORM_CONFIG[m.platform];
              const isReplied = m.replied || replied.has(m.id);
              const isReplying = replyingTo === m.id;

              return (
                <div key={m.id} className={`px-5 py-4 transition-colors ${isReplying ? 'bg-violet-50/50' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-start gap-3">

                    {/* Avatar */}
                    <div className="relative shrink-0">
                      {m.author.avatar ? (
                        <img src={m.author.avatar} alt="" className="w-9 h-9 rounded-full object-cover" />
                      ) : (
                        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center text-gray-600 font-bold text-sm">
                          {m.author.name[0]?.toUpperCase()}
                        </div>
                      )}
                      {/* Platform badge */}
                      <div className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full ${cfg?.bg || 'bg-gray-100'} border border-white flex items-center justify-center`}>
                        {cfg?.icon}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="font-semibold text-gray-900 text-sm">{m.author.name}</span>
                        {m.rating && <Stars rating={m.rating} />}
                        <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full border ${cfg?.bg} ${cfg?.color} ${cfg?.border}`}>
                          {cfg?.label} · {m.type === 'review' ? 'Avis' : m.type === 'reply' ? 'Réponse' : 'Commentaire'}
                        </span>
                        {isReplied && (
                          <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
                            ✓ Répondu
                          </span>
                        )}
                        <span className="text-[11px] text-gray-400 ml-auto shrink-0">{timeAgo(m.date)}</span>
                      </div>

                      <p className="text-sm text-gray-700 mt-1 leading-relaxed">{m.content}</p>

                      {m.postSnippet && (
                        <p className="text-[11px] text-gray-400 mt-1 truncate">
                          <span className="font-medium">↳</span> {m.postSnippet}
                        </p>
                      )}

                      {/* Actions */}
                      {!isReplied && m.type !== 'reply' && (
                        <div className="mt-2">
                          {!isReplying ? (
                            <button onClick={() => { setReplyingTo(m.id); setReplyText(''); setError(null); }}
                              className="flex items-center gap-1.5 text-xs font-semibold text-violet-600 hover:text-violet-800 transition-colors">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-3.5 h-3.5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"/>
                              </svg>
                              Répondre
                            </button>
                          ) : (
                            <div className="flex gap-2 mt-1">
                              <textarea
                                autoFocus
                                value={replyText}
                                onChange={e => setReplyText(e.target.value)}
                                placeholder={`Répondre à ${m.author.name}…`}
                                rows={2}
                                className="flex-1 px-3 py-2 text-sm border border-violet-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-violet-400 resize-none bg-white"
                              />
                              <div className="flex flex-col gap-1.5">
                                <button onClick={() => handleReply(m)} disabled={sending || !replyText.trim()}
                                  className="px-4 py-2 bg-gradient-to-r from-violet-600 to-indigo-600 text-white text-xs font-bold rounded-xl hover:from-violet-700 hover:to-indigo-700 transition-all disabled:opacity-50">
                                  {sending ? '…' : 'Envoyer'}
                                </button>
                                <button onClick={() => { setReplyingTo(null); setReplyText(''); }}
                                  className="px-4 py-2 bg-gray-100 text-gray-600 text-xs font-semibold rounded-xl hover:bg-gray-200 transition-colors">
                                  Annuler
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
